// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types'; 
import classNames from 'classnames/bind';
 
import style from './Card.scss';
 
type Props = {
    className?: string;
    icon: string;
    title: string;
    textBody: string;
};

type State = {  
};

 
export default class Card extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = { 
    };
  } 

  render() {  
    const {className, icon, title, textBody} = this.props;
    return (  
        <div  className={classNames(style.root, `${className ? className : ''}`)}>
            <div className={style.contentWrap}>
                <div className={style.titleContent}>
                    <div  className={style.imageWrap}>
                        <img src={icon} alt="icon-card"/>
                    </div> 
                    <div className={style.titleWrap}>
                        <h4 className={style.title}>{title}</h4>
                    </div>
                </div>

                <span className={style.textBody}>{textBody}</span> 
            </div>
            
        </div>
    );
  }
}


Card.propTypes = { 
    className:PropTypes.string,
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    textBody: PropTypes.string.isRequired
};
 



// WEBPACK FOOTER //
// ./src/modules/home/elements/FeaturesCards/Card/Card.jsx